import React from 'react';
import { rem } from 'polished';
import styled, { css } from 'styled-components';

import { breakpoints, misc } from 'helpers/styles/constants';

import { pagePadding } from '../styled';

interface InnerWrapperProps {
  hasMarginTopMd?: boolean;
}

const margin = (value: number) => css<InnerWrapperProps>`
  margin-top: ${rem(value)};

  ${({ hasMarginTopMd }) =>
    hasMarginTopMd &&
    css`
      margin-top: ${rem(value - 20)};
    `};
`;

const InnerWrapper = styled.div<InnerWrapperProps>`
  ${pagePadding};
  ${margin(misc.dashboardMargin - 30)};
  display: flex;
  flex-direction: column;
  padding-bottom: ${rem(50)};

  @media ${breakpoints.smUp} {
    ${margin(misc.dashboardMargin)};
  }

  @media ${breakpoints.xlUp} {
    ${margin(misc.dashboardMarginXl)};
  }
`;

interface Props {
  children: React.ReactNode;
  topSection?: React.ReactNode;
}

const PageContent = ({ children, topSection }: Props) => (
  <>
    {topSection}

    <InnerWrapper role="main" data-test="client-dashboard" hasMarginTopMd={Boolean(topSection)}>
      {children}
    </InnerWrapper>
  </>
);

export default PageContent;
